import { component as defineComponent } from 'flightjs';
import $ from 'jquery';

function ContentToggle() {
    this.defaultAttrs({
        select: '[data-content-toggle-select]',
        bodyContainer: '[data-content-toggle-body-container]',
    });

    this.after('initialize', function() {
        this.on('change', {
            select: this.changeVisibleContentBody,
        });
    });

    this.changeVisibleContentBody = function(e, data) {
        const option = data.el.selectedOptions[0];
        const contentId = $(option).data('content-toggle-content-id');
        const bodyContainer = this.select('bodyContainer');
        bodyContainer.find('[data-content-toggle-content]').attr('data-visible', false);
        bodyContainer
            .find(`[data-content-toggle-content-id=${contentId}]`)
            .attr('data-visible', true);
    };
}

export default defineComponent(ContentToggle);



// WEBPACK FOOTER //
// ./src/js/component_ui/content-toggle.js